import ModulWithImage from './ModulWithImage';
import {ImageModuleData} from './image/interfaces';

export default class ModulImageSubtitle extends ModulWithImage {
    helpArticleId = 'imagesubtitle';

    protected data: ImageModuleData;

    /**
     * @override
     * purely for typing purposes
     */
    getData() {
        return this.data;
    }

    setFullwidth(fullwidth: boolean) {
        this.modul.toggleClass('diyfeLiveArea', !fullwidth);
    }

    getSaveData() {
        let state = this.getData();
        let data = super.getSaveData();

        let newData = Object.assign(data, {
            isFullwidth: state.isFullwidth ? 1 : 0
        });

        return newData;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulImageSubtitle.ts
 **/